/**
 * Establecer un valor para la variable subscriber.
 */
export function setSubscriber(state, subscriber) {
    state.subscriber = subscriber;
}

/**
 * Establecer un valor para la variable loading.
 */
export function setLoading(state, loading) {
    state.loading = loading;
}



// WEBPACK FOOTER //
// ./src/modules/b2c_integration/mutations.js